import React, {useEffect, useState} from 'react';
import {MDBInput} from "mdb-react-ui-kit";
// react plugin used to create datetimepicker
import ReactDatetime from "react-datetime";
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Row,
  CustomInput,
  Col
} from "reactstrap";
import axios from "axios";
import { INSERT_IVR_CAMPAIGN,CHANNEL_CLIENT_CHNLTYPE,FETCH_GROUP_NAMES,IVR_CALLFLOW_NAMES_LIST } from "../../constants";
import SampleCSV from "./ivr.csv"
import NotificationAlert from "react-notification-alert";
import moment from "moment";
import LoadingScreen from "react-loading-screen";
import logo from "../../assets/img/logo.png";

var initialValues ={
  callflow:"",
  file: "",
  name: "",
  message: "",
  date:moment().format("YYYY-MM-DD HH:mm A"),
  templateid:"",
  contactGroup:"",
  senderid:"",
  priority1:{
    templateid:"",
    channel:"",
    senderid:""
  },
  priority2:{
    templateid:"",
    channel:"",
    senderid:""
  },
  priority3:{
    templateid:"",
    channel:"",
    senderid:""
  },
  priority4: {
    templateid: "",
    channel: "",
    senderid: "",
  }
}
let templates = [];
let senderids = [];
let groups = [];
let callflowList = [];



let smstemplates = [];
let smssenderids = [];

let rcstemplates = [];
let rcssenderids = [];

let emailtemplates = [];
let emailsenderids = [];

let ivrtemplates = [];
let ivrsenderids = [];
var channels =[
  {
    value: "",
    label: "Select Channel",
    isDisabled: true,
  },
  { value: 'SMS', label: "SMS" },
  { value: 'Email', label: "Email" },
  { value: 'RCS', label: "RCS" },
  { value: "IVR", label: "IVR" },
];

let userObj = localStorage.getItem("user");
const password = localStorage.getItem("password");
let user = JSON.parse(userObj);
const Createcampaigns = () => {


  const [ivrCampaign, setIvrCampaign] = useState(initialValues);

  const [validation, setValidation] = useState({ isvalid: false, message: "" });
  const notificationAlertRef = React.useRef(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [channel, setChannel] = useState([]);
  const [channelsms, setChannelsms] = useState([]);
  const [channelemail, setChannelemail] = useState([]);
  const [channelrcs, setChannelrcs] = useState([]);
  const [channelivr, setChannelivr] = useState([]);
  const [errorhandle,setErrorHandle]= useState();
  const [iscalbck, setiscalbck] = useState(false);
  const [ismanual,setIsManual] = useState(0)
  const [error,setError] = useState({
    error:"",
    iserror:false
  })

  useEffect(()=>{
    fetchChanelsbyClient();
    fetchSmsChanelsbyClient();
    fetchEmailChanelsbyClient();
    fetchWhatsappChanelsbyClient();
    fetchRcsChanelsbyClient();
    viewGroupList();
    fetchCallflow();

  },[])

  const viewGroupList = (pageNo) => {
    let lcObj = localStorage.getItem("user");
    let lclStrge = JSON.parse(lcObj);
    let clientid=lclStrge?.client;
    let user_id=lclStrge?.user_id;

    axios
      .get(`${FETCH_GROUP_NAMES}?user_id=${user_id}`)
      .then((response) => {
        groups=[]
        response?.data?.message?.map((group,i)=>{
          
          group?.name&&groups.push({ value:group?.name, label: group?.name })
         
       })
        setIsLoading(false)
      })
      .catch((error) => {
        console.log("err==>", error)
        setIsLoading(false)
        let options = {};
        options = {
          place: "tr",
          message: error?.code,
          type: "warning",

          autoDismiss: 2,
        };
        notificationAlertRef?.current?.notificationAlert(options);
      });
  };


  const fetchCallflow=async()=>{
    setIsLoading(true)
  
    user?.client!=0&&(await axios.get(IVR_CALLFLOW_NAMES_LIST).then(res=>{
    
      if(res?.data){
      callflowList=[]
      
     

      res?.data?.message?.map((ivr,i)=>{
        ivr?.callflow_name&&callflowList.push({ value:ivr?.callflow_name, label: ivr?.callflow_name })
       
     })
    }
    }))
  }
  const fetchChanelsbyClient=async()=>{
    setIsLoading(true)

    const payload={
      channels_type:"ivr",
      clintId:user?.client
    }
    user?.client!=0&&(await axios.post(CHANNEL_CLIENT_CHNLTYPE,payload).then(res=>{
    
      if(res?.data){
      templates=[]
      
     
      
      //setIvrCampaign(res?.data)
      setChannel(res?.data)

      res?.data?.map((wtsap,i)=>{
        wtsap?.template&&templates.push({ value:wtsap?.template, label: wtsap?.template })
       
     })
    }
      setIsLoading(false)
     }).catch(e=>{
     
      let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
    }))

  }

  
   //Fetching Template by RCS Channel

   const fetchRcsChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "rcs",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          rcstemplates = [];
          const chnlObj = res?.data[0];

          setChannelrcs(res?.data);
        //  setIvrCampaign({ ...ivrCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              rcstemplates.push({ value: item?.template, label: item?.template });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          console.log("Error---",e);
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }));
  };


   //Fetching Template by IVR Channel

   const fetchWhatsappChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "whatsapp",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          ivrtemplates = [];
          const chnlObj = res?.data[0];

          setChannelivr(res?.data);
         // setIvrCampaign({ ...ivrCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              ivrtemplates.push({ value: item?.template, label: item?.template });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }));
  };

    //Fetching Template by SMS Channel

    const fetchSmsChanelsbyClient = async () => {
      setIsLoading(true);
  
      const payload = {
        channels_type: "sms",
        clintId: user?.client,
      };
      user?.client != 0 &&
        (await axios
          .post(CHANNEL_CLIENT_CHNLTYPE, payload)
          .then((res) => {
            smstemplates = [];
            const chnlObj = res?.data[0];
  
            setChannelsms(res?.data);
           // setIvrCampaign({ ...ivrCampaign, peid: chnlObj.peid });
  
            res?.data?.map((item, i) => {
              item?.template &&
                smstemplates.push({ value: item?.template, label: item?.template });
            });
  
            setIsLoading(false);
          })
          .catch((e) => {
            let options = {};
            options = {
              place: "tr",
              message: e.code,
              type: "warning",
              autoDismiss: 2,
            };
            notificationAlertRef?.current?.notificationAlert(options);
          }));
    };

      //Fetching Template by Email Channel

  const fetchEmailChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "email",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          emailtemplates = [];
          const chnlObj = res?.data[0];
       
          setChannelemail(res?.data);
        //  setsmsCampaign({ ...smsCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              emailtemplates.push({ value: item?.template, label: item?.template });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }));
  };


  const changeSender=(data)=>{
    senderids=[]
    const chnl=channel.filter(item=>item.template==data.value)
      
    const senderid = chnl[0]?.senderid?.split(",");
        for(let i=0;i<senderid?.length;i++){
          senderids.push({label:senderid[i],value:senderid[i]})
        }
    setIvrCampaign(prev=>({...prev,templateid:data,senderid:"",message: chnl[0]?.content}))

  }

  const fetchSenderId=(data,chnl)=>{
    if(chnl=="SMS")
    {
     smssenderids = [];
     const chnls = channelsms?.filter((item) => item.template == data.value);
     const senderid = chnls[0]?.senderid?.split(",");
     for (let i = 0; i < senderid?.length; i++) {
      smssenderids.push({ label: senderid[i], value: senderid[i] });
     }
   }
   else if(chnl=="Email"){
    emailsenderids = [];
    const chnls = channelemail?.filter((item) => item.template == data.value);
    const senderid = chnls[0]?.senderid?.split(",");
    for (let i = 0; i < senderid?.length; i++) {
      emailsenderids.push({ label: senderid[i], value: senderid[i] });
    }
   }
   else if(chnl=="RCS"){
     rcssenderids = [];
     const chnls = channelrcs?.filter((item) => item.template == data.value);
     const senderid = chnls[0]?.senderid?.split(",");
     for (let i = 0; i < senderid?.length; i++) {
       rcssenderids.push({ label: senderid[i], value: senderid[i] });
     }
   }
    else if(chnl=="IVR"){
     ivrsenderids = [];
     const chnls = channelivr?.filter((item) => item.template == data.value);
     const senderid = chnls[0]?.senderid?.split(",");
     for (let i = 0; i < senderid?.length; i++) {
       ivrsenderids.push({ label: senderid[i], value: senderid[i] });
     }
   }
  
  

 }

 const checkvalue = (value, priority) => {
  if (priority == "priority1") {
    if (ivrCampaign?.priority2?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority2",
        value,
      });
      setIvrCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority1: { ...preemailCampaign?.priority1, channel: "",templateid:"",senderid:"" },
      }));
    } else if (ivrCampaign?.priority3?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority3",
        value,
      });
      setIvrCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority1: { ...preemailCampaign?.priority1, channel: "",templateid:"",senderid:"" },
      }));
    }else if (ivrCampaign?.priority4?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority4",
        value,
      });
      setIvrCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority1: { ...preemailCampaign?.priority1, channel: "" ,templateid:"",senderid:""},
      }));
    } else {
      setError({
        iserror: false,
        errorhandle: "",
      });
      setIvrCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority1: { ...preemailCampaign?.priority1, channel: value ,templateid:"",senderid:""},
      }));
    }
  } else if (priority == "priority2") {
    if (ivrCampaign?.priority1?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority1",
        value,
      });
      setIvrCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority2: { ...preemailCampaign?.priority2, channel: "",templateid:"",senderid:"" },
      }));
    } else if (ivrCampaign?.priority3?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority3",
        value,
      });
      setIvrCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority2: { ...preemailCampaign?.priority2, channel: "" ,templateid:"",senderid:""},
      }));
    } else if (ivrCampaign?.priority4?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority4",
        value,
      });
      setIvrCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority2: { ...preemailCampaign?.priority2, channel: "",templateid:"",senderid:"" },
      }));
    } else {
      setError({
        iserror: false,
        errorhandle: "",
      });
      setIvrCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority2: { ...preemailCampaign?.priority2, channel: value,templateid:"",senderid:"" },
      }));
    }
  } else if (priority == "priority3") {
    if (ivrCampaign?.priority1?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority1",
        value,
      });
      setIvrCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority3: { ...preemailCampaign?.priority3, channel: "" ,templateid:"",senderid:""},
      }));
    } else if (ivrCampaign?.priority2?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority2",
        value,
      });
      setIvrCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority3: { ...preemailCampaign?.priority3, channel: "" ,templateid:"",senderid:""},
      }));
    } else if (ivrCampaign?.priority4?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority4",
        value,
      });
      setIvrCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority3: { ...preemailCampaign?.priority3, channel: "" ,templateid:"",senderid:""},
      }));
    }
     else {
      setError({
        iserror: false,
        errorhandle: "",
      });
      setIvrCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority3: { ...preemailCampaign?.priority3, channel: value ,templateid:"",senderid:""},
      }));
    }
  } else if (priority == "priority4") {
    if (ivrCampaign?.priority1?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority1",
        value,
      });
      setIvrCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority4: { ...preemailCampaign?.priority4, channel: "" ,templateid:"",senderid:""},
      }));
    } else if (ivrCampaign?.priority2?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority2",
        value,
      });
      setIvrCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority4: { ...preemailCampaign?.priority3, channel: "" ,templateid:"",senderid:""},
      }));
    }  else if (ivrCampaign?.priority3?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority3",
        value,
      });
      setIvrCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority4: { ...preemailCampaign?.priority4, channel: "" ,templateid:"",senderid:""},
      }));
    } 
    
    else {
      setError({
        iserror: false,
        errorhandle: "",
      });
      setIvrCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority4: { ...preemailCampaign?.priority4, channel: value,templateid:"",senderid:"" },
      }));
    }
  }
};

 const submitIVR = () =>{
 
  const isValid = validate()
  setErrorHandle(isValid)
  if(Object.keys(isValid).length==0){
    let slctddate ="";
    setIsLoading(true);
    if(moment(ivrCampaign.date).format("YYYY-MM-DD HH:mm") != "Invalid date"){
      slctddate = moment(ivrCampaign.date).format("YYYY-MM-DD HH:mm");
    }else{
      slctddate =ivrCampaign.date.slice(0,-2) ;
    }
    const formData = new FormData();
    if( ivrCampaign?.file){
      formData.append("file", ivrCampaign.file);
    }
    //formData.append("file", ivrCampaign.file);
    formData.append("name", ivrCampaign.name);
    formData.append('date', slctddate);
    formData.append("user_id",user.user_id)
    formData.append("client_id",user?.client)
    formData.append("username",user?.username)
    formData.append("password",password)
    formData.append("callflow",ivrCampaign?.callflow?.value)
    formData.append("senderid",ivrCampaign.senderid?.value)
    formData.append("message", ivrCampaign?.message)
    formData.append('template',  ivrCampaign.templateid?.value);
    formData.append('priority1',  ivrCampaign?.priority1?.channel);
    formData.append('templateid1',  ivrCampaign?.priority1?.templateid?.value);
    formData.append('senderid1',  ivrCampaign?.priority1?.senderid?.value);
    formData.append('priority2',  ivrCampaign?.priority2?.channel);
    formData.append('templateid2',  ivrCampaign?.priority2?.templateid?.value);
    formData.append('senderid2',  ivrCampaign?.priority2?.senderid?.value);
    
    formData.append('priority3',  ivrCampaign?.priority3?.channel);
    formData.append('templateid3',  ivrCampaign?.priority3?.templateid?.value);
    formData.append('senderid3',  ivrCampaign?.priority3?.senderid?.value);

    
    formData.append('priority4',  ivrCampaign.priority4?.channel?.value);
    formData.append('templateid4',  ivrCampaign.priority4?.templateid?.value);
    formData.append('senderid4',  ivrCampaign?.priority4?.senderid?.value);
    formData.append('contactgroup',  ivrCampaign?.contactGroup?.value);

    




    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    axios
      .post(INSERT_IVR_CAMPAIGN, formData, config)
      .then((response) => {
        setIsLoading(false)
        let options = {};
        options = {
          place: "tr",
          message: "Submitted Successfully",
          type: "success",

          autoDismiss: 2,
        };
        notificationAlertRef.current.notificationAlert(options);
       
        setIvrCampaign(initialValues)
       
      })
      .catch((err) => {
        console.log("err==>", err)
        setIsLoading(false)
        let options = {};
        options = {
          place: "tr",
          message: err?.response?.data?.message,
          type: "warning",

          autoDismiss: 2,
        };
        notificationAlertRef?.current?.notificationAlert(options);
      });
  }
  
  }

  const validate=()=>{
    const onlylettersRegex =/^[a-zA-Z ]+$/;
    let errors={}
    if(!ivrCampaign.name){
      errors.name="Please Enter Name"
    } else if(ivrCampaign?.name?.length<=3){
      errors.name="Please Enter Valid Name"
    }else if(!(ivrCampaign.name.match(onlylettersRegex))){
      errors.name="Please Enter Valid Name"
    }
    
    if(!ivrCampaign?.templateid?.value){
      errors.templateid="Please Select Template"
    }
    if(!ivrCampaign?.senderid?.value){
      errors.senderid="Please Select Sender Id"
    }
    // if(!ivrCampaign.file){
    //   errors.file="Please Upload File "
    // }
    return errors;
   }


  const chooseFile = (e) => {
    let a = e.target.value.split(".");

    if (a[1] == "xlsx" || a[1] == "csv") {
      setValidation({
        isvalid: false,
        message: " ",
      });
      setIvrCampaign({ ...ivrCampaign, file: e.target.files[0]});
    } else {
      setValidation({
        isvalid: true,
        message: "Not Supported " + a[1] + " format",
      });
    }
  };

  
  
  return (
    
    <>
   
      <div className="content">
      <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
      <NotificationAlert ref={notificationAlertRef} />
        <Row>
          
      <Col md="12" className='pt-2'>
            <Card>
              
        
              <CardBody>
                <Form action="#">
                <Row>
                <Col md="3" sm='12'>
                    <label>Name *</label>
                    <FormGroup>
                      <Input type="Text" placeholder='Enter Name' value={ivrCampaign.name} onChange={(e) =>setIvrCampaign({...ivrCampaign,name:e.target.value})} />
                    </FormGroup>
                    {errorhandle?.name&&<span style={{color:"red"}}>{errorhandle?.name}</span>}
                  </Col>
                  <Col md="3" sm='12'>
                  <p className="category">Select Date & Time *</p>
                  <FormGroup>
                  <ReactDatetime
                    inputProps={{
                      className: "form-control",
                      placeholder: "Date & Time"
                    }}
                    closeOnSelect={true}
                    timeFormat={true}
                    value={ivrCampaign.date}
                    onChange={(val) =>setIvrCampaign({...ivrCampaign,date:val._d})}
                  />
                </FormGroup>
                  </Col>
                  <Col md="3" sm="12">
          <p className="category">Select Callflow<suf style={{color:"red"}}>*</suf> </p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="templateSelect"
            value={ivrCampaign?.callflow}
            onChange={(value) => setIvrCampaign({...ivrCampaign,callflow:value})}
            options={callflowList}
            placeholder="Select"
          />
          {errorhandle?.templateid&&<span style={{color:"red"}}>{errorhandle?.templateid}</span>}
        </Col>

                    <Col md="3" sm="12">
          <p className="category">Select Template<suf style={{color:"red"}}>*</suf> </p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="templateSelect"
            value={ivrCampaign.templateid}
            onChange={(value) => changeSender(value)}
            options={templates}
            placeholder="Select"
          />
          {errorhandle?.templateid&&<span style={{color:"red"}}>{errorhandle?.templateid}</span>}
        </Col>
        <Col md="3" sm="12">
          <p className="category">Select Sender</p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="senderSelect"
            value={ivrCampaign?.senderid}
            onChange={(value) => setIvrCampaign(prev=>({...prev,senderid:value}))}
            options={senderids}
            placeholder="Select"
          />
           {errorhandle?.senderid&&<span style={{color:"red"}}>{errorhandle?.senderid}</span>}
        </Col> 
        <Col md="3" sm="12">
                      <Label>Message Text</Label>
                      <Input
                        style={{ padding: "5px", resize:"auto",maxHeight:"none" }}
                        type="textarea"
                        name="message"
                        
                        value={ivrCampaign?.message}
                        placeholder="Message Text"
                        onChange={(e) => {
                          setIvrCampaign({
                            ...ivrCampaign,
                            message: e.target.value,
                          });
                        }}
                      />
                      {/* {errorhandle?.message && (
                        <span style={{ color: "red" }}>
                          {errorhandle?.message}
                        </span>
                      )} */}
                    </Col>
                    <Col sm="3" className="mb-2 mt-2">
                      <div className="d-flex align-items-center">
                        <span className="mr-2">Group </span>
                        <CustomInput
                          type="switch"
                          id="switch-5"
                          className="mt-n4"
                          checked={ismanual===0?true:false}
                          onChange={(e) =>{
                            e.target.checked==true?setIvrCampaign({...ivrCampaign,contactGroup:""}):setIvrCampaign({...ivrCampaign,file:""})
                             setIsManual(e.target.checked==true?0:1)
                            }
                            }
                        />
                        <span className="ml-n2">File</span>
                      </div>
                    </Col>
       
        {error.iserror&&<h6 style={{color:"red"}}>{error.errorhandle}</h6>}
                 
               
                    {
                        ismanual==0?<Col md="3" sm="12" className="">
                          <Label>
                            Bulk Upload (<b>Upload CSV File</b>)
                          </Label>
    
                          <FormGroup>
                            <Input
                              placeholder="placeholder"
                              accept=".csv"
                              onChange={(e) => chooseFile(e)}
                              type="file"
                              style={{
                                opacity: "1",
                                position: "initial",
                                border: "solid 1px #eee",
                              }}
                            />
                          <a href={SampleCSV} download ="ivr Sample File">  <p style={{marginLeft:"40%",color:"#e14eca"}}>*Download sample csv file</p></a>
                          </FormGroup>
                         
                            <span style={{ color: "red" }}>
                              {errorhandle?.file}
                            </span>
                         
                        </Col>:
                               <Col md="3" sm="12">
                               <p className="category">Contact Groups</p>
                               <Select
                                 className="react-select info"
                                 classNamePrefix="react-select"
                                 name="groupSelect"
                                 value={ivrCampaign.contactGroup}
                                 onChange={(value) => setIvrCampaign({...ivrCampaign,contactGroup:value})}
                                 options={groups}
                                 placeholder="Select"
                               />
                               {errorhandle?.templateid&&<span style={{color:"red"}}>{errorhandle?.templateid}</span>}
                             </Col>
                    }
           
                    
                    <Col md="3" className="mb-2 ">
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={iscalbck}
                            value={iscalbck}
                            onClick={(e) => {
                              e.target.checked === true
                              ? setiscalbck(true)
                              : setiscalbck(false);
                            }}
                          />
                          <span className="form-check-sign" />
                          Fall back
                        </Label>
                      </FormGroup>
                    </Col>
                    </Row>
                    {iscalbck && (
                    <>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="1" className="mb-2 ">
                          <Label>Priority 1</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            // value={.smsSlct}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority1");
                              //setIvrCampaign({...ivrCampaign,priority1.channel: value});
                             //  setIvrCampaign((preemailCampaign)=>({...preemailCampaign,priority1:{...preemailCampaign.priority1,channel:value}}))
                            }}
                            options={channels}
                            placeholder="Select Channel"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                             value={ivrCampaign?.priority1?.templateid}
                            onChange={(value) => {
                              setIvrCampaign((preemailCampaign)=>({...preemailCampaign,priority1:{...preemailCampaign.priority1,templateid:value}}))
                            
                               fetchSenderId(value,ivrCampaign.priority1.channel)
                            }}
                             options={ivrCampaign?.priority1?.channel=="Email"?emailtemplates:ivrCampaign?.priority1?.channel=="IVR"?ivrtemplates:ivrCampaign?.priority1?.channel=="SMS"?smstemplates:rcstemplates}
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderId"
                        value={ivrCampaign?.priority1?.senderid}
                        onChange={(value) => {
                          setIvrCampaign((preemailCampaign)=>({...preemailCampaign,priority1:{...preemailCampaign.priority1,senderid:value}}))
                        }}
                        options={ivrCampaign?.priority1?.channel=="Email"?emailsenderids:ivrCampaign?.priority1?.channel=="IVR"?ivrsenderids:ivrCampaign?.priority1?.channel=="SMS"?smssenderids:rcssenderids}
                       
                           
                        placeholder="Select SenderId"
                      />
                    </Col>
                      </Row>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="1" className="mb-2 ">
                          <Label>Priority 2</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            options={channels}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority2");
                              
                              //setIvrCampaign({...ivrCampaign,priority1.channel: value});
                               //  setIvrCampaign((preemailCampaign)=>({...preemailCampaign,priority2:{...preemailCampaign.priority2,channel:value}}))
                            }}
                           
                            placeholder="Select Channel"
                          />
                        </Col>

                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                             value={ivrCampaign?.priority2?.templateid}
                            onChange={(value) => {
                              setIvrCampaign((preemailCampaign)=>({...preemailCampaign,priority2:{...preemailCampaign.priority2,templateid:value}}))
                            
                              fetchSenderId(value,ivrCampaign.priority2.channel)
                           
                            }}
                            // options={selectType}
                            options={ivrCampaign?.priority2?.channel=="Email"?emailtemplates:ivrCampaign?.priority2?.channel=="IVR"?ivrtemplates:ivrCampaign?.priority2?.channel=="SMS"?smstemplates:rcstemplates}
                          
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderId"
                        value={ivrCampaign?.priority2?.senderid}
                        onChange={(value) => {
                          setIvrCampaign((preemailCampaign)=>({...preemailCampaign,priority2:{...preemailCampaign.priority2,senderid:value}}))
                        }}
                        options={ivrCampaign?.priority2?.channel=="Email"?emailsenderids:ivrCampaign?.priority2?.channel=="IVR"?ivrsenderids:ivrCampaign?.priority2?.channel=="SMS"?smssenderids:rcssenderids}
                       
                           
                        placeholder="Select SenderId"
                      />
                    </Col>
                      </Row>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="1" className="mb-2 ">
                          <Label>Priority 3</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            options={channels}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority3");
                              //setIvrCampaign({...ivrCampaign,priority1.channel: value});
                             //  setIvrCampaign((preemailCampaign)=>({...preemailCampaign,priority3:{...preemailCampaign.priority3,channel:value}}))
                            }}
                           
                            placeholder="Select Channel"
                          />
                        </Col>

                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                             value={ivrCampaign?.priority3?.templateid}
                            onChange={(value) => {
                              setIvrCampaign((preemailCampaign)=>({...preemailCampaign,priority3:{...preemailCampaign.priority3,templateid:value}}))
                            
                              fetchSenderId(value,ivrCampaign.priority3.channel)
                            }}
                            options={ivrCampaign?.priority3?.channel=="Email"?emailtemplates:ivrCampaign?.priority3?.channel=="IVR"?ivrtemplates:ivrCampaign?.priority3?.channel=="SMS"?smstemplates:rcstemplates}
                          
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderId"
                        value={ivrCampaign?.priority3?.senderid}
                        onChange={(value) => {
                          setIvrCampaign((preemailCampaign)=>({...preemailCampaign,priority3:{...preemailCampaign.priority3,senderid:value}}))
                        }}
                        options={ivrCampaign?.priority3?.channel=="Email"?emailsenderids:ivrCampaign?.priority3?.channel=="IVR"?ivrsenderids:ivrCampaign?.priority3?.channel=="SMS"?smssenderids:rcssenderids}
                       
                           
                        placeholder="Select SenderId"
                      />
                    </Col>
                      </Row>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="1" className="mb-2 ">
                          <Label>Priority 4</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            options={channels}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority4");
                              //setIvrCampaign({...ivrCampaign,priority1.channel: value});
                             //  setIvrCampaign((preemailCampaign)=>({...preemailCampaign,priority4:{...preemailCampaign.priority4,channel:value}}))
                            }}
                           
                            placeholder="Select Channel"
                          />
                        </Col>

                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                             value={ivrCampaign?.priority4?.templateid}
                            onChange={(value) => {
                              setIvrCampaign((preemailCampaign)=>({...preemailCampaign,priority4:{...preemailCampaign?.priority4,templateid:value}}))
                            
                              fetchSenderId(value,ivrCampaign.priority4.channel)
                             }}
                            options={ivrCampaign?.priority4?.channel=="Email"?emailtemplates:ivrCampaign?.priority4?.channel=="IVR"?ivrtemplates:ivrCampaign?.priority4?.channel=="SMS"?smstemplates:rcstemplates}
                          
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderId"
                        value={ivrCampaign?.priority4?.senderid}
                        onChange={(value) => {
                          setIvrCampaign((preemailCampaign)=>({...preemailCampaign,priority4:{...preemailCampaign.priority4,senderid:value}}))
                        }}
                        options={ivrCampaign?.priority4?.channel=="Email"?emailsenderids:ivrCampaign?.priority4?.channel=="IVR"?ivrsenderids:ivrCampaign?.priority4?.channel=="SMS"?smssenderids:rcssenderids}
                       
                           
                        placeholder="Select SenderId"
                      />
                    </Col>
                      </Row>
                    </>
                  )}
        <Row>
                   
                    <Col md="1" sm="12">
                      <Button
                        color="primary pull-right"
                        className="mt-4 btn btn-icon animation-on-hover"
                        id="tooltipsubmit"
                        type="button"
                        disabled={isLoading===true&&"true"}
                        onClick={() => submitIVR()}
                      >
                        <i
                          className="tim-icons icon-double-right"
                          
                        />
                      </Button>
                     
                    </Col>
                 
                  
              </Row>
                
                </Form>
              </CardBody>
              
            </Card>
          </Col>
          <Col md="3"></Col>
          </Row>
      </div>
    </>
  )
}

export default Createcampaigns
